import { AsText, chevronDirections, IconChevron } from '@adserve/adserve-react-components';
import React, { useState, useRef } from 'react';
import {
    monthlyPoInputStyle,
    monthlyPoNumberLabelStyle,
    monthlyPoNumberValueStyle,
    poNumberInputStyle,
    poNumberLabelStyle
} from './CampaignBriefStyles';
import HorizontalInfoPipe from './HorizontalInfoPipe/HorizontalInfoPipe';
import MonthlyPoList from './MonthlyPoList';

const PoNumberInput = ({
    campaign = {},
    readOnly = false,
    handlePoSingleChange,
    handlePoMonthlyChange
}) => {
    const monthlyInputRef = useRef(null);
    const [showing, setShowing] = useState(false);

    const handleMonthlyClick = () => {
        if (!readOnly && campaign.startDate && campaign.endDate) {
            setShowing(!showing);
        }
    };

    const handleClickOutside = (event) => {
        if (!monthlyInputRef.current.contains(event.target)) {
            setShowing(false);
        }
    };

    return (
        <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', width: '100%', gap: '0 20px' }}>
                <div>
                    <AsText
                        id='campaign-po-number'
                        name='poNumber'
                        title={window.translate('PO Number')}
                        labelStyle={poNumberLabelStyle}
                        inputStyle={{
                            ...poNumberInputStyle,
                            width: '100%',
                            color: campaign?.poNumbersJson?.usingSingle ? '#414141' : '#C0C0C0'
                        }}
                        value={campaign?.poNumbersJson?.single}
                        onChange={handlePoSingleChange}
                        disabled={readOnly}
                    />
                </div>
                <div>
                    <div
                        style={{
                            position: 'absolute'
                        }}
                    >
                        <span style={monthlyPoNumberLabelStyle}>{window.translate('Monthly PO Number')}</span>
                    </div>

                    <div
                        ref={monthlyInputRef}
                        id='campaign-monthly-po-number-input'
                        name='monthlyPoNumberId'
                        title={window.translate('Monthly PO Number')}
                        style={monthlyPoInputStyle(readOnly || !campaign.startDate || !campaign.endDate)}
                        onClick={handleMonthlyClick}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                right: 12
                            }}
                        >
                            <IconChevron direction={chevronDirections.DOWN}  fill={'#414141'} size={17} />
                        </div>
                        <span style={monthlyPoNumberValueStyle(!campaign?.poNumbersJson?.usingSingle)}>
                            {campaign?.poNumbersJson?.multiple?.length > 1
                                ? '(Multiple)'
                                : campaign?.poNumbersJson?.multiple
                                    ? campaign?.poNumbersJson?.multiple[0]?.poNumber
                                    : ''}
                        </span>
                    </div>
                </div>
                <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'center' }}>
                    <HorizontalInfoPipe text={window.translate('One required')} />
                </div>
            </div>
            <MonthlyPoList
                campaign={campaign}
                setShowing={setShowing}
                handlePoMonthlyChange={handlePoMonthlyChange}
                boundingRect={monthlyInputRef?.current?.getBoundingClientRect()}
                onClickOutside={handleClickOutside}
                showing={showing}
            />
        </>
    );
};

export default PoNumberInput;
